import { create } from "zustand";
import { persist } from "zustand/middleware";

interface ShiftFeedState {
  /** True when the worker has explicitly opted into the availability filter.
   *  Default false — fresh workers and never-toggled sessions see all open
   *  shifts. Persists per-browser so a deliberate choice survives reloads. */
  availableOnly: boolean;
  setAvailableOnly: (value: boolean) => void;
  reset: () => void;
}

export const useShiftFeedStore = create<ShiftFeedState>()(
  persist(
    (set) => ({
      availableOnly: false,
      setAvailableOnly: (value) => set({ availableOnly: value }),
      reset: () => set({ availableOnly: false }),
    }),
    { name: "oneshift-shift-feed" },
  ),
);
